// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"5eb10144","228":"581266b0","519":"2de7a400","740":"35b698ab"}[chunkId] + ".chunk.css";
};